export enum FermetureTabEnum {
  JOUR = 'jour',
  PERIODE = 'periode'
}
